import React from 'react';
import PaddingBox from '@uds/padding-box';
import ProductPrice from 'components/common/ProductPrice';
import { Layout, PricingStrategy } from 'components/common/ProductPrice/constants';
import { Panel } from '@uds/panel';
import { Heading04 } from '@uds/typography';
import { selectors as prodSelectors, Product } from '@uds/product';
import { Colorway } from '@uds/theme-utils';
import withUrlComponent from 'presentation/hooks/withUrlComponent';
import { Alignment } from 'domain/constants/alignment';

import getClassNames from './CardLink.stylesheet';

export type SavingType = {
  type: string;
  value: number;
  currency: string;
};
interface OuterProps {
  saving: SavingType;
  hBaseline: number;
  colorway: Colorway;
  url: string;
  badge: string;
  product: Product;
  pricingStrategy: PricingStrategy;
  alignment: Alignment;
}

const { getName } = prodSelectors;

const PureCardLink = ({ hBaseline, product, pricingStrategy, saving, badge, url, colorway, alignment }: OuterProps) => {
  const classNames = getClassNames({ colorway });

  const { Component } = withUrlComponent({ url });

  return (
    <Component className={classNames.root} href={url} to={url}>
      <Panel className={classNames.card}>
        <PaddingBox>
          <Heading04 depth={hBaseline} data-alignment={alignment} className={classNames.domainName}>
            {getName({ product })}
          </Heading04>
          <ProductPrice
            product={product}
            saving={saving}
            showLegalCaveat={false}
            showFee={false}
            pricingStrategy={pricingStrategy}
            badge={badge}
            priceLayout={Layout.COMPACT}
          />
        </PaddingBox>
      </Panel>
    </Component>
  );
};

PureCardLink.displayName = 'CardLink';

export default PureCardLink;
